class videoHelper{
	constructor() {
		
	}
	vidoeKill() {
		if ($('.modal-video')[0]) {
			$('.modal-video').each(function () {
				var modal = $(this),
					btn = $(this).find('button.close')[0],
					tar = $(this).find('.modal-body')[0];
				$(btn).data('dismiss', false);
				$(btn).click(function (e) {
					e.preventDefault();
					var html = $(tar).html();
					$(tar).html(html);
					modal.modal('hide');
				});
			});
		}
	}
	loadiframe(el) {
		console.log('loading iframe');
		$(el).on('show.bs.modal', function() {
			var $iframe = $(el).find('.iframe');
			$iframe.attr('src', $iframe.data('src'));
		});
		$(el).on('hidden.bs.modal', function() {
			var $iframe = $(el).find('.iframe');
			$iframe.attr('src', '');
		});
	}
}
window.app.add('video', new videoHelper());